import { inject } from 'inversify';
import { Injectable } from '../../decorators/injectable';
import { HttpService, type IHttpService } from '../http/http.service';
import type {
  IMunicipalityService as IMunicipalityServiceInterface,
  MunicipalityResult,
} from './municipality.service.interface';

@Injectable()
export class MunicipalityService implements IMunicipalityServiceInterface {
  constructor(@inject(HttpService) private readonly http: IHttpService) {}

  async search(query: string): Promise<MunicipalityResult[]> {
    return this.http.get<MunicipalityResult[]>(
      `municipalities?search=${encodeURIComponent(query)}`,
    );
  }
}
